<template>
  <div class="virtual-account-container" @click.stop>
    <div class="credit-card-container" pointClass="j-open-credit-card">
      <p class="title-tips">{{ letter.pleaseCard }}</p>
      <div class="card-container">
        <div
          class="card-item j-credit-card-item credit-card-ico-wrap"
          v-for="(card, index) in creditCardList"
          :class="{ active: curCreditCard === card }"
          :pointValue="card"
          @click="selectCreditCard(card)"
          :key="index"
        >
          <img
            class="pay-way-icon"
            :src="getCurPayWayIcon(card)"
            alt="payway icon"
          />
          <div
            class="choose-active active-ico iconfont icon-choose active"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PAYTYPE_ICON_URL } from '@utiles/officialStore';
import {
  GET_CARD_SCHEMES_ACTION,
  SET_CREDIT_CARD
} from '@store/officialWebStore';
import { mapState } from 'vuex';
export default {
  name: 'CreditCard',
  props: {
    curPayType: {
      require: true
    },
    curLocationVal: {
      require: true
    },
    discountTransMount: {
      require: true
    },
    curCoins: {
      require: true
    },
    isCoins: {
      require: true
    }
  },
  data() {
    return {};
  },
  methods: {
    getCurPayWayIcon(cardType) {
      return PAYTYPE_ICON_URL + 'credit_card/' + cardType + '.png';
    },
    selectCreditCard(card) {
      this.$store.commit(SET_CREDIT_CARD, card);
      window.webstorev2DataLayer.push({
        eventName: 'select_credit_card',
        eventValue: {
          credit_type: card
        }
      });
    },
    getCardSchemes() {
      // 金额有三种情况：购物车、非购物车、代币
      let amount = 0;
      amount = this.isCoins
        ? this.curCoins.TRANS_AMOUNT
        : this.discountTransMount;
      this.$store.dispatch(GET_CARD_SCHEMES_ACTION, {
        currency: this.curPayType.currency,
        game_id: this.$store.state.gameId,
        location: this.curLocationVal,
        amount: amount
      });
    }
  },
  created() {
    this.getCardSchemes();
  },
  watch: {
    // 如果使用优惠券则重新请求接口
    discountTransMount() {
      if (this.isCoins) {
        return;
      }
      this.getCardSchemes();
    },
    curCoins() {
      if (this.isCoins) {
        this.getCardSchemes();
      }
    }
  },
  computed: {
    ...mapState({
      creditCardList: state => state.creditCardList,
      curCreditCard: state => state.creditCard,
      letter: state => state.letter
    })
  },
  components: {}
};
</script>
